import { layoutRect, layoutCoordinate } from "../../utils/displayDensity";
/* eslint-disable */
import { PieChart, Users } from "lucide-react";
import { XboxArt, XboxArtPlaceholder, changeTone, fmtChange, fmtEstimated, fmtShare } from "./xboxUi";

// Visual pattern mirrors TwitchCard: tilt + glare hover, rank badge, gradient stat band, "+" compare.
function XboxTitleCard({ row, index }) {
  const showLabels = index === 0;
  const tone = changeTone(row.change);

  const onEnter = (e) => {
    const card = e.currentTarget.querySelector("[data-xbox-card]");
    if (!card) return;
    card.style.transition = "transform 220ms cubic-bezier(.2,.8,.2,1)";
    card.style.transform = "perspective(900px) translateZ(0) scale(1.02)";
  };
  const onMove = (e) => {
    const card = e.currentTarget.querySelector("[data-xbox-card]");
    if (!card) return;
    const r = layoutRect(e.currentTarget);
    const x = (layoutCoordinate(e.clientX) - r.left) / r.width;
    const y = (layoutCoordinate(e.clientY) - r.top) / r.height;
    card.style.transform = `perspective(900px) rotateX(${-(y - 0.5) * 8}deg) rotateY(${(x - 0.5) * 8}deg) scale(1.04)`;
    card.style.setProperty("--mx", `${x * 100}%`);
    card.style.setProperty("--my", `${y * 100}%`);
    card.classList.add("is-glare");
  };
  const onLeave = (e) => {
    const card = e.currentTarget.querySelector("[data-xbox-card]");
    if (!card) return;
    card.style.transition = "transform 300ms ease";
    card.style.transform = "perspective(900px) rotateX(0) rotateY(0) scale(1)";
    card.classList.remove("is-glare");
  };

  return (
    <div
      className="xbox-card-wrap"
      onMouseEnter={onEnter}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      aria-label={`Rank ${row.rank}, ${fmtShare(row.share)} player share, estimated ${fmtEstimated(row.estimatedPlayers)}`}
    >
      <div data-xbox-card className="xbox-card">
        <div className="xbox-card-art">
          <XboxArt
            candidates={row.title.mainArt}
            width={400}
            alt={row.title.name}
            eager={index < 10}
            fallback={<XboxArtPlaceholder />}
          />
        </div>

        <div className="xbox-card-rank">#{row.rank}</div>

        {row.isNew ? (
          <div className="xbox-card-change is-new">New</div>
        ) : row.change != null ? (
          <div className={`xbox-card-change is-${tone}`}>{fmtChange(row.change)}</div>
        ) : null}

        <div className="xbox-card-footer">
          <div className="xbox-card-stats is-split">
            <div className="xbox-card-stat">
              {showLabels && <span className="xbox-card-stat-label">Share</span>}
              <div className="xbox-stat-line">
                <span className="xbox-stat-icon"><PieChart size={14} /></span>
                <b>{fmtShare(row.share)}</b>
              </div>
            </div>
            <div className="xbox-card-stat is-right">
              {showLabels && <span className="xbox-card-stat-label">Est. Players</span>}
              <div className="xbox-stat-line xbox-card-estimate">
                <span className="xbox-stat-icon"><Users size={14} /></span>
                <b>{fmtEstimated(row.estimatedPlayers)}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function XboxTitleCardGrid({ rows, loading, columns }) {
  if (loading) {
    return (
      <div className="xbox-card-grid" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
        {Array.from({ length: columns * 2 }).map((_, i) => (
          <div key={i} className="xbox-card-skel" style={{ animationDelay: `${i * 60}ms` }} />
        ))}
      </div>
    );
  }
  return (
    <div className="xbox-card-grid" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {rows.map((row, i) => (
        <XboxTitleCard
          key={row.titleId}
          row={row}
          index={i}
        />
      ))}
    </div>
  );
}
